import { Typography } from '@mui/material';

/**
 * La volanta de categoría sobre un titular, en el **color del cliente**: es identidad, no
 * estado — si mañana la marca es verde o naranja, esto cambia de color y la jerarquía de la
 * página no se mueve (la sostienen el tamaño, el peso y las reglas).
 *
 * **La usa solo la portada** (`Portada.tsx`). En todos los demás lugares donde aparece una nota, la
 * lista que la contiene ya dice de qué sección es —el rótulo del bloque, el título de la página, el
 * "Más de…"— y nombrarla otra vez en cada titular es repetir lo de arriba. Peor: el nombre sale de
 * `categories[0]`, así que en una nota clasificada en varias categorías nombraba una cualquiera, y
 * dentro del bloque de Tecnología podía leerse "TURISMO". La portada es la excepción porque es la
 * única grilla armada a mano, donde cada nota viene de una sección distinta y no hay rótulo que lo
 * diga.
 */
export function VolantaCategoria({ nombre }: { nombre: string | undefined }) {
  if (!nombre) return null;
  return (
    <Typography variant="volanta" component="p" sx={{ color: 'var(--color-cliente)', mb: 0.5 }}>
      {nombre}
    </Typography>
  );
}
